export default __webpack_public_path__ + "static/img_2_0-5686d7d231d745482486fc1ab15d8a25.webp";